import { render, staticRenderFns } from "./ReschedulesHistory.vue?vue&type=template&id=65d01c6e"
import script from "./ReschedulesHistory.vue?vue&type=script&lang=js"
export * from "./ReschedulesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports